import { combineReducers } from 'redux';

import { componentReducers } from './components/reducer';

const rootReducer = combineReducers({
  ...componentReducers,
});

export default rootReducer;
